
import AccountBody from '@/pages/account/components/AccountBody.vue';
import LoyaltyMembership from '@/pages/account/components/LoyaltyMembership.vue';
export default {
  layout: 'account',
  middleware: 'auth',
  components: { AccountBody, LoyaltyMembership },
};
